module.exports = __webpack_public_path__ + "img/slide3.76325ab2.png";